var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccordionClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11C22.448 11 22 11.448 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C14.6845 2 17.2045 3.049 19.0965 4.954C19.485 5.346 20.1185 5.3485 20.5105 4.959C20.9025 4.57 20.9045 3.937 20.5155 3.545C18.2455 1.259 15.221 0 12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 11.448 23.552 11 23 11Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H13V8C13 7.448 12.552 7 12 7C11.448 7 11 7.448 11 8V11H8C7.448 11 7 11.448 7 12C7 12.552 7.448 13 8 13H11V16C11 16.552 11.448 17 12 17C12.552 17 13 16.552 13 16V13H16C16.552 13 17 12.552 17 12C17 11.448 16.552 11 16 11Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionClosed);
export default __webpack_public_path__ + "static/media/AccordionClosed.8a42ab4c1035f251c2dc6bcaa105803b.svg";
export { ForwardRef as ReactComponent };